import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-legal-layout',
  standalone: true,
  imports: [CommonModule, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section class="cr-legal">
      <div class="cr-legal__inner">
        <a routerLink="/" class="cr-legal__nav">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/>
          </svg>
          Zurück zur Startseite
        </a>

        <header class="cr-legal__head">
          <span *ngIf="eyebrow" class="cr-legal__eyebrow">{{ eyebrow }}</span>
          <h1 class="cr-legal__title">{{ title }}</h1>
          <p *ngIf="lastUpdated" class="cr-legal__meta">Stand: {{ lastUpdated }}</p>
        </header>

        <article class="cr-legal__prose">
          <ng-content></ng-content>
        </article>

        <p *ngIf="footerNote" class="cr-legal__footer-meta">{{ footerNote }}</p>
      </div>
    </section>
  `,
})
export class LegalLayoutComponent {
  @Input() title = '';
  @Input() eyebrow?: string;
  @Input() lastUpdated?: string;
  @Input() footerNote?: string;
}
